import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Typography } from '@mui/material';
export const BulletItem = t0 => {
  const $ = _c(12);
  const {
    title,
    leftContent,
    rightContent
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = title && <Typography sx={{
      width: "540px"
    }} variant="body1">{title}</Typography>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== leftContent) {
    t2 = <Box width="440px">{leftContent}</Box>;
    $[2] = leftContent;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Stack gap="24px">{t1}{t2}</Stack>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== rightContent) {
    t4 = <Box width="50%">{rightContent}</Box>;
    $[7] = rightContent;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <Stack width="100%" direction="row" gap="100px" justifyContent="space-between">{t3}{t4}</Stack>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};